import { render, staticRenderFns } from "./SpecialLogo.vue?vue&type=template&id=6becda72&"
import script from "./SpecialLogo.vue?vue&type=script&lang=js&"
export * from "./SpecialLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports